import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import spartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-input-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';
import { layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { numericInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { htmlEscaper } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"modals") : stack1)) != null ? lookupProperty(stack1,"zipCodeGatingModalValid") : stack1),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":0},"end":{"line":25,"column":9}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<form id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "Form\" name=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "Form\" autocomplete=\"off\" novalidate>\r\n  <div class=\"row\">\r\n    <div class=\"column small-12\">\r\n      <div class=\"headline-large valid-modal-header\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"header") : depth0), depth0)) != null ? stack1 : "")
    + "</div>\r\n      <p class=\"modal-body\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"body") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"column small-8 medium-6 large-6 modal-input-box\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"numericInput")||(depth0 && lookupProperty(depth0,"numericInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputBox") : depth0),{"name":"numericInput","hash":{},"data":data,"loc":{"start":{"line":18,"column":6},"end":{"line":18,"column":38}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <div class=\"column small-4 medium-6 large-6 modal-sparta-button\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"button") : depth0),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":21,"column":6},"end":{"line":21,"column":30}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n</form>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\r\n  <div class=\"column small-12\">\r\n    <div class=\"headline-large invalid-modal-header\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"modals") : stack1)) != null ? lookupProperty(stack1,"zipCodeGatingModalInvalid") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n    <p class=\"modal-body\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"modals") : stack1)) != null ? lookupProperty(stack1,"zipCodeGatingModalInvalid") : stack1)) != null ? lookupProperty(stack1,"body") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n  </div>\r\n</div>\r\n<div class=\"row\">\r\n  <div class=\"column small-4 medium-6 large-6 modal-sparta-button\">\r\n    "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"modals") : stack1)) != null ? lookupProperty(stack1,"zipCodeGatingModalInvalid") : stack1)) != null ? lookupProperty(stack1,"button") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":37,"column":4},"end":{"line":37,"column":62}}})) != null ? stack1 : "")
    + "\r\n  </div>\r\n</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"modals") : stack1)) != null ? lookupProperty(stack1,"zipCodeGatingModalValid") : stack1),{"name":"layerContent","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":0},"end":{"line":26,"column":17}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"modals") : stack1)) != null ? lookupProperty(stack1,"zipCodeGatingModalInvalid") : stack1),{"name":"layerContent","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":0},"end":{"line":40,"column":17}}})) != null ? stack1 : "")
    + "\r\n<div  id=\"zipCodeGatingModalCampaigns\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":42,"column":49},"end":{"line":42,"column":63}}}))
    + "\"></div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/zip-code-gating-modal-module",
  "version": "4.0.0",
  "id": "zipCodeGatingModalModule",
  "containerID": "creditCardsZipCodeGatingModalModule",
  "moduleName": "credit-cards-zip-code-gating-modal-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "zip-code-gating-modal-module",
  "data": {
    "init": "ZipCodeGatingModalModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        button,
        layerContent,
        numericInput,
        json,
        htmlEscaper
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    button,
    layerContent,
    numericInput,
    json,
    htmlEscaper
  },
  "dependencies": {
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-input-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.6",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-validation-framework-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* eslint-disable no-console */
/**
 * Implementation of the zip-code-gating-modal-module module.
 * @copyright 2021-2-3
 * @since 2/3/2021, 1:22:27 PM
 * @author Jesse Price
 * @file
 */

/* global */

const LOADING_INDICATOR_CLASS = 'loading-indicator';
const STORE_NAME = 'ccZipGated';
const STORE_TYPE = 'sessionStorage';

/**
 * The ZipCodeGatingModalModule Sparta Module.
 * ZIP Code gating for card eligibility apply buttons
 * @export
 * @class
 */
class ZipCodeGatingModalModule extends Module {
  /**
   * Creates an instance of ZipCodeGatingModalModule.
   * @memberof ZipCodeGatingModalModule
   * @param {*} options The options
   * @returns {undefined}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.campaigns = {};
    this.campaignIds = [];
    this.currentCampaign = null;
    this.currentApplyUrl = null;
    this.validationRules = {};
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {undefined}
   */
  init() {
    const $target = $('#zipCodeGatingModalValid', this.applicationContainer);
    this.settings.$target = $target;
    $target.spartaInputs({
      validate: false
    });
    this.Validation = spartaValidationFramework.fn.core;
    this.inputModalBody = document.querySelector('#zipCodeGatingModalValid p.modal-body');
    this.inputModalForm = document.getElementById('zipCodeGatingModalValidForm');
    this.inputModalFormZipInput = document.getElementById('zipCodeGatingModalInputField');
    this.inputModalFormSubmit = document.getElementById('zipCodeGatingModalSubmit');
    this.invalidModalBody = document.querySelector('#zipCodeGatingModalInvalid p.modal-body');
    this.invalidModalHeader = document.querySelector('.invalid-modal-header');
    const jcrElem = document.getElementById('zipCodeGatingModalCampaigns');
    try {
      this.json = JSON.parse(jcrElem.dataset.jcr);
      this.campaigns = this.json.campaigns;
      this.campaignIds = Object.keys(this.campaigns);
    } catch (err) {
      console.error(err);
    }
    this.modalContent = this.json.modals;
    this.bindValidationRules();
    this.bindSubscribeEvents();
    this.bindFormSubmitEvents();
  }

  /**
   * Opens zip code modal
   * @returns {undefined}
   */
  openZipCodeModal() {
    spartaUILayersUtility.openLayer('#zipCodeGatingModalValid');
  }

  /**
   * Close zip code modal
   * @returns {undefined}
   */
  closeZipCodeModal() {
    spartaUILayersUtility.closeLayer();
  }

  /**
   * Method for opening not available modal
   * @param {Boolean} response has response
   * @returns {void}
   */
  openZipCodeInvalidModal(response) {
    if (response !== false) {
      spartaUILayersUtility.openLayer('#zipCodeGatingModalInvalid');
    } else {
      this.invalidModalHeader.innerHTML = this.modalContent.zipCodeGatingModalInvalid.noBackendHeader;
      this.invalidModalBody.innerHTML = this.modalContent.zipCodeGatingModalInvalid.noBackendBody;
      spartaUILayersUtility.openLayer('#zipCodeGatingModalInvalid');
    }
  }

  /**
   * Bind validation rules that were declared in the JCR.
   * Also allow for custom validation rules when a testFunction is defined in the JCR.
   * @returns {undefined}
   */
  bindValidationRules() {
    const {
      $target
    } = this.settings;
    const formValidations = {};
    $target.find('[data-validation-rules]').each((index, field) => {
      const $field = $(field);
      const id = $field.attr('id');
      const rules = $field.data('validation-rules');
      const testFunctions = {};
      formValidations[id] = rules;
      if (rules.change && rules.change.customFunction) {
        const {
          testFunction,
          errorMessage
        } = rules.change.customFunction;
        formValidations[id].change.customFunction = {
          parameters: [testFunctions[testFunction].bind(this, $field)],
          errorMessage
        };
      }
      $field.removeAttr('data-validation-rules');
    });
    this.validationRules = formValidations;
    this.Validation.bindValidationRules(formValidations, true);
  }

  /**
   * Binds apply ctas by id
   * @param {string} prefixId prefix of the id
   * @returns {undefined}
   */
  bindApplyCtas(prefixId) {
    this.campaignIds.forEach(campaignId => {
      // Note, querySelector will not work with the ids due to ~
      const applyCta = document.getElementById(`${prefixId}${campaignId}`);
      this.setApplyCtaEventListener(applyCta, campaignId);
    });
  }

  /**
   * Bind apply now ctas for card comparison table
   * @returns {undefined}
   */
  bindCardCompareApplyCtas() {
    ['apply_now_', 'apply_now_bottom_'].forEach(prefixId => {
      this.bindApplyCtas(prefixId);
    });
  }

  /**
   * Bind apply now ctas for card details product pages
   * @param {string} campaignId id of the card
   * @returns {undefined}
   */
  bindCardDetailsApplyCtas(campaignId) {
    // Need to make these ids unique
    const applyNowCtas = document.querySelectorAll('#applyNow_engagement');
    [...applyNowCtas].forEach(applyCta => {
      this.setApplyCtaEventListener(applyCta, campaignId);
    });
  }

  /**
   * Bind carousel apply ctas
   * @returns {undefined}
   */
  bindCarouselApplyCtas() {
    const applyNowCtas = document.querySelectorAll('#carouselCcModule [data-campaign-id]');
    [...applyNowCtas].forEach(applyCta => {
      const campaignId = applyCta.getAttribute('data-campaign-id');
      if (campaignId && this.campaignIds.indexOf(campaignId) > -1) {
        this.setApplyCtaEventListener(applyCta, campaignId);
      }
    });
  }

  /**
   * Handles the apply link click event.
   * @param {Event} event handled event
   * @param {HTMLElement} applyCta apply link
   * @returns {undefined}
   */
  handleApplyLink(event, applyCta) {
    const campaignId = applyCta.getAttribute('data-zip-code-gating');
    const storeData = this.Store.getPersisted(STORE_NAME, STORE_TYPE) || [];
    this.currentApplyUrl = applyCta.href;
    this.currentCampaign = this.campaigns[campaignId] || null;
    if (this.currentCampaign) {
      this.invalidModalBody.innerHTML = this.currentCampaign.invalidMessage;
      this.inputModalBody.innerHTML = this.currentCampaign.defaultMessage;

      // Check if campaign has already been submitted.
      if (storeData.indexOf(this.currentCampaign.shieldKey) === -1) {
        this.openZipCodeModal(campaignId);
        event.preventDefault();
      } else {
        this.showLoadingOverlay(event);
      }
    }
  }

  /**
   * Subscribe to events.
   * @returns {undefined}
   */
  bindSubscribeEvents() {
    // Card list module
    this.Events.sub(creditCardUtility.EVENTS.cardListReady, () => {
      this.bindApplyCtas('home_');
      this.bindApplyCtas('home_small_');
    });

    // Comparison table module
    this.Events.sub(creditCardUtility.EVENTS.compareTableReady, this.bindCardCompareApplyCtas.bind(this));

    // Card details page
    this.Events.sub(creditCardUtility.EVENTS.productDetailsReady, payload => {
      this.bindCardDetailsApplyCtas(payload.data.campaignId);
    });

    // Card finder quiz page
    this.Events.sub(creditCardUtility.EVENTS.quizReady, () => {
      this.bindApplyCtas('cardFinder_applyNow_');
      this.bindApplyCtas('cardFinder_applyNow_small_');
    });

    // Carousel links
    this.Events.sub(creditCardUtility.EVENTS.carouselReady, () => {
      this.bindCarouselApplyCtas();
    });
  }

  /**
   * Bind form submit.
   * @returns {undefined}
   */
  bindFormSubmitEvents() {
    this.inputModalForm.addEventListener('submit', this.handleFormSubmit.bind(this));
  }

  /**
   * Handles form submit.
   * @param {Object} event object
   * @returns {undefined}
   */
  handleFormSubmit(event) {
    event.preventDefault();
    if (!this.isFormValid()) return;
    this.showLoadingIndicator();
    creditCardUtility.requestShield(this.currentCampaign.shieldKey).then(response => {
      this.hideLoadingIndicator();
      if (!response) this.openZipCodeInvalidModal(false); // if response does not come back

      const zipCode = this.inputModalFormZipInput.value;
      if (response.exclude) {
        if (response.exclude[zipCode]) {
          this.openZipCodeInvalidModal(true);
        } else {
          this.closeZipCodeModal();
          this.showLoadingOverlay(event);
          window.location.href = this.currentApplyUrl;
        }
      } else if (response.include) {
        if (response.include[zipCode]) {
          this.closeZipCodeModal();
          this.showLoadingOverlay(event);
          window.location.href = this.currentApplyUrl;
        } else {
          this.openZipCodeInvalidModal(true);
        }
      }
      const storeData = this.Store.getPersisted(STORE_NAME, STORE_TYPE) || [];
      storeData.push(this.currentCampaign.shieldKey);
      this.Store.persist(STORE_NAME, storeData, STORE_TYPE);
    }).catch(err => {
      this.hideLoadingIndicator();
      this.openZipCodeInvalidModal(false);
      console.error(err);
    });
  }

  /**
   * Handles included, allowed campaigns
   * @returns {undefined}
   */
  handleInclude() {
    if (!document.documentElement.classList.contains('mda')) {
      this.closeZipCodeModal();
      this.Events.pub(creditCardUtility.EVENTS.loaderShow, {});
      window.location.href = this.currentApplyUrl;
    }
  }

  /**
   * Check if form is valid
   * @returns {Boolean} Is form valid?
   */
  isFormValid() {
    const $input = $(this.inputModalFormZipInput);
    const isValidRequired = this.Validation.validateRequiredFields($input);
    const isValidRules = this.Validation.validateRules($input, this.validationRules[$input.attr('id')].change);
    return isValidRequired && isValidRules;
  }

  /**
   * Sets apply cta event listener
   * @param {HTMLElement} applyCta apply link
   * @param {string} campaignId apply link campaign id
   * @returns {undefined}
   */
  setApplyCtaEventListener(applyCta, campaignId) {
    if (!applyCta) return;
    if (!applyCta.hasAttribute('data-zip-code-gating')) {
      applyCta.setAttribute('data-zip-code-gating', campaignId);
      applyCta.addEventListener('click', event => {
        this.handleApplyLink(event, applyCta);
      });
    }
  }

  /**
   * Shows the loading indicator.
   * @returns {undefined}
   */
  showLoadingIndicator() {
    const span = document.createElement('span');
    span.classList.add(LOADING_INDICATOR_CLASS);
    this.inputModalFormSubmit.appendChild(span);
  }

  /**
   * Hides the loading indicator.
   * @returns {undefined}
   */
  hideLoadingIndicator() {
    const span = this.inputModalFormSubmit.querySelector(`.${LOADING_INDICATOR_CLASS}`);
    if (span) {
      span.remove();
    }
  }

  /**
   * Shows the loading overlay while navigating to application.
   * @param {Event} event object
   * @returns {undefined}
   */
  showLoadingOverlay(event) {
    const isNewTabKeyHeld = event.ctrlKey || event.shiftKey || event.metaKey || event.button && event.button === 1; // Middle click IE9
    const notMda = !document.documentElement.classList.contains('mda');
    if (!isNewTabKeyHeld && notMda) {
      this.Events.pub(creditCardUtility.EVENTS.loaderShow, {});
    }
  }
}
registerModuleClass({
  moduleClass: ZipCodeGatingModalModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ZipCodeGatingModalModule as default, moduleConfig };
